<template>
  <section>
    <div v-if="digestLoading" class="fade my-6 border border-white border-opacity-20 rounded-md bg-sp-secondary bg-opacity-70">
      <Loading />
    </div>
    
    <div v-else key="digest">
      <div v-if="newsData.length > 0">
        <div v-for="(item, index) in newsData" :key="index" class="flex flex-col gap-2 my-6 p-4 break-words text-sp-primary border border-white border-opacity-20 rounded-md bg-sp-secondary bg-opacity-70">
          <h3 class="text-sm">{{ formatDate(item.createdAt) }}</h3>
          <h3 class="text-center">{{ item.title }}</h3>
          <p v-html="parseLinks(item.description)" class="digest-text"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getUserData } from '../modules/collectData.js'
import { useHelpCenterFetch } from '../composables/useHelpCenterFetch'
import Loading from './Loading.vue'

const router = useRouter()
const { uid, lang, platform, game, signature } = getUserData()

const limit = 2
const offset = 0
const path = `news/many?limit=${limit}&offset=${offset}&order=desc&locale=${lang}&uid=${uid}&platform=${platform}&game=${game}&token=${signature}`

const { data, loading: digestLoading, error, load } = useHelpCenterFetch(() => path)

const newsData = computed(() => {
  const answer = data.value
  return (answer && answer.count > 0) ? answer.entities : []
})

watch(error, (isError) => {
  if (isError) router.push({ name: 'helpcenter' })
})

function formatDate(timestamp) {
  const date = new Date(timestamp * 1000)
  const options = { day: 'numeric', month: 'long', year: 'numeric' }
  return lang ? date.toLocaleDateString(lang, options) : date.toLocaleDateString('en', options)
}

function parseLinks(text) {
  if (!text) return ''

  const escapeHtml = (unsafe) => unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")

  const escapedText = escapeHtml(text)
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return escapedText.replace(urlRegex, (url) =>
    `<a href="${url}" target="_blank" rel="noopener noreferrer" class="digest-link">${url}</a>`
  )
}

load()
</script>

<style scoped>
.digest-text :deep(a.digest-link) {
  text-decoration: underline;
  transition: color 150ms ease-in-out;
}
</style>